import { HashLink } from "react-router-hash-link"
import { ReactComponent as LOGOUT } from "../../assets/LockOpen.svg"
import { useAuth } from "../context/AuthContext"
import { TCompanyData } from "../../api/apiCalls"

export default function Header({ companyData, logo }: { companyData?: TCompanyData; logo?: string }) {
    const auth = useAuth()

    return (
        <div className="navbar" style={{ backgroundColor: companyData?.color }}>
            <div className="flex-1">
                <HashLink to={"/"} className="btn btn-ghost normal-case text-xl cursor-pointer">
                    {logo && <img src={logo} alt="LogoOfCompany" className="h-10 w-fit max-w-[8rem] rounded-default" />}
                    <p className="text-base-100 text-base">Kundenportal</p>
                </HashLink>
            </div>
            <button type="button" className="flex px-8 text-sm font-semibold text-base-100 gap-2 cursor-pointer" onClick={() => void auth.logout()}>
                <LOGOUT className="w-6 h-6" />
                <p>Logout</p>
            </button>
        </div>
    )
}
